import SurveyFrecuency from './SurveyFrecuency.jsx';

export default SurveyFrecuency;